"use client";

import * as React from "react";

/**
 * Снимает фокус с «постороннего» элемента в момент открытия модального слоя.
 *
 * Radix при открытии Dialog/AlertDialog/Sheet ставит aria-hidden на всё вне окна
 * (useEffect внутри Content), а фокус переносит внутрь чуть позже. Если окно
 * открылось само — «Что нового» после загрузки, окно после перехода по ссылке, —
 * фокус в этот момент ещё стоит, например, на ссылке навигации в шапке, и Chrome
 * пишет «Blocked aria-hidden on an element because its descendant retained focus».
 * Скринридер при этом на мгновение остаётся на скрытом элементе.
 *
 * Компонент кладётся первым ребёнком внутрь Radix Content: он монтируется ровно
 * при открытии, а useLayoutEffect выполняется раньше любых useEffect, то есть до
 * aria-hidden. Фокус с триггера окна НЕ снимаем (у триггеров Radix есть
 * aria-haspopup / data-state) — иначе после закрытия фокус не вернётся на кнопку.
 */
export function ReleaseStrayFocus() {
  React.useLayoutEffect(() => {
    const active = document.activeElement;
    if (!(active instanceof HTMLElement) || active === document.body) return;
    if (active.hasAttribute("aria-haspopup") || active.hasAttribute("data-state")) return;
    active.blur();
  }, []);

  return null;
}
